import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Col, Container, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import PageTitle from '../../common/page-title/index';
import UserTitleSelector from '../../common/form/user/user-title-selector';
import UserFirstNameInput from '../../common/form/user/user-first-name-input';
import UserLastNameInput from '../../common/form/user/user-last-name-input';
import ArrowButton from '../../common/button-arrow';
import BsCheckbox from '../../common/form/elements/bs-checkbox';
import { getAdminMyProfile, saveAdminMyProfile, updateMyProfileEmail } from '../../../actions/user';
import { validators } from '../../../utils/validators';
import ChangeEmailDialog from './change-email-dialog';

import './style.css';

const model = 'deep.admin_my_profile';

class MyProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDialogOpen: false,
      originalEmail: '',
      payload: null
    };
  }

  componentDidMount() {
    const { dispatch, location: { search } } = this.props;
    const token = new URLSearchParams(search).get('email_change_token');

    this.resetChangeEmailDialogFields();

    if (token) {
      dispatch(updateMyProfileEmail(token, true));
    } else {
      dispatch(getAdminMyProfile());
    }
  }

  componentDidUpdate(prevProps) {
    const { isLoading } = this.props;

    if (prevProps.isLoading !== isLoading && !isLoading) {
      const { profile: { attributes: { email } } } = this.props;

      this.loadFormData();
      this.setState({ originalEmail: email });
    }
  }

  loadFormData = () => {
    const { dispatch, profile: { attributes } } = this.props;
    const data = {
      title: attributes.title || undefined,
      first_name: attributes['first-name'] || undefined,
      last_name: attributes['last-name'] || undefined,
      comms_email: attributes['comms-email'] || false,
      comms_mobile: attributes['comms-mobile'] || false,
      email: attributes.email || undefined,
      mobile: attributes.mobile || undefined,
    };

    dispatch(actions.load('deep.admin_my_profile', data));
  }

  onSubmit = (payload) => {
    const { dispatch } = this.props;
    const { originalEmail } = this.state;
    const payLoad = { ...payload };

    if (originalEmail !== payLoad.email) {
      this.handleOpenDialog(payLoad);
    } else {
      dispatch(actions.submitFields('deep.admin_my_profile', saveAdminMyProfile(payLoad)));
    }
  };

  handleOpenDialog = (payload) => {
    this.setState({ isDialogOpen: true, payload });
  };

  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false, payload: null }, () => {
      this.resetChangeEmailDialogFields();
    });
  }

  resetChangeEmailDialogFields = () => {
    const { dispatch } = this.props;

    dispatch(actions.change('deep.my_profile_change_email_dialog.password', ''));
    dispatch(actions.reset('deep.my_profile_change_email_dialog'));
  }

  handleSubmitDialog = (result) => {
    if (result) {
      const { changeEmailDialogForm, dispatch } = this.props;
      const { payload } = this.state;
      const password = changeEmailDialogForm.password.value;

      dispatch(actions.submitFields('deep.admin_my_profile', saveAdminMyProfile(payload, password)));
    }

    this.handleCloseDialog();
  }

  pageTitleComponent = () => (
    <Row>
      <Col md={12}>
        <PageTitle>
          My Profile
        </PageTitle>
      </Col>
    </Row>
  );

  render() {
    const { isLoading } = this.props;
    const { isDialogOpen } = this.state;

    if (isLoading) {
      return (
        <Container fluid className="my-profile">
          {this.pageTitleComponent()}
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </Container>
      );
    }

    return (
      <div>
        <Container fluid className="my-profile">
          {this.pageTitleComponent()}
          <Row>
            <Col md={12}>
              <h4>
                Personal Details
              </h4>
            </Col>
          </Row>
          <Form
            model={model}
            onSubmit={payload => this.onSubmit(payload)}
          >
            <Row className="show-grid profile-details">
              <Col md={6}>
                <UserTitleSelector model="deep.admin_my_profile.title"/>
                <UserFirstNameInput/>
                <UserLastNameInput/>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <FormLabel>
                    Communication preferences*
                  </FormLabel>
                  <Errors
                    className="errors"
                    messages={{
                      communication: 'You must select at least one communication preference.'
                    }}
                    model="deep.about_you.user"
                    show={{touched: true}}
                  />
                  <Row>
                    <Col md={3}>
                      <FormGroup>
                        <Control.checkbox component={BsCheckbox} model=".comms_email">
                          Email
                        </Control.checkbox>
                      </FormGroup>
                    </Col>
                    <Col md={9}>
                      <FormGroup controlId="email">
                        <Control.text
                          component={FormControl}
                          disabled={!this.props.comms_email}
                          model=".email"
                          placeholder="Email"
                          type="email"
                          validators={{
                            required: val => !this.props.comms_email || validators.required(this.updateErrors, 'email')(val)
                          }}
                        />
                        <Errors
                          className="errors"
                          model=".email"
                          show={{
                            touched: true,
                            focus: false
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                      <FormGroup>
                        <Control.checkbox component={BsCheckbox} model=".comms_mobile">
                          Mobile
                        </Control.checkbox>
                      </FormGroup>
                    </Col>
                    <Col md={9}>
                      <FormGroup controlId="mobile">
                        <Control.text
                          component={FormControl}
                          disabled={!this.props.comms_mobile}
                          model=".mobile"
                          placeholder="Mobile"
                          type="tel"
                          validators={{
                            required: val => !this.props.comms_mobile || validators.required(this.updateErrors, 'mobile')(val)
                          }}
                        />
                        <Errors
                          className="errors"
                          model=".mobile"
                          show={{
                            touched: true,
                            focus: false
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <ArrowButton
                  className="float-end"
                  color="grey"
                  disabled={!this.props.form.$form.valid || !(this.props.comms_email || this.props.comms_mobile)}
                >
                  Save
                </ArrowButton>
              </Col>
            </Row>
          </Form>
        </Container>
        {isDialogOpen && <ChangeEmailDialog handleCloseDialog={this.handleSubmitDialog} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: !state.currentUser.fetched && state.currentUser.fetching,
  profile: state.currentUser.profile,
  comms_mobile: !!state.deep.admin_my_profile.comms_mobile,
  comms_email: !!state.deep.admin_my_profile.comms_email,
  form: state.deep.forms.admin_my_profile,
  changeEmailDialogForm: state.deep.forms.my_profile_change_email_dialog
});

export default connect(mapStateToProps)(MyProfile);
